<template>
  <div>
    <Achievements/>
    <CardList :cards="cards"/>

    <Spinner class="offer-spinner" size="large" color="red" v-if="loading"/>
    <OffersSection v-else :offers="lastActiveOffers"/>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { namespace, State } from 'vuex-class'
import dayjs from 'dayjs'
import { fixIsoDate } from '@/helpers'
import Spinner from '@/common/components/Spinner.vue'
import CardList from '../components/CardList.vue'
import Achievements from '../components/Achievements'
import OffersSection from '../components/OffersSection'

const cards = namespace('cards')
const accruals = namespace('accruals')
const offers = namespace('offers')

@Component({
  components: { CardList, Achievements, OffersSection, Spinner }
})
class Dashboard extends Vue {
  @cards.State cards
  @cards.State errors
  @offers.State loading
  @offers.State lastOffers
  @State(({ auth: { user } }) => user) user

  @accruals.Action fetchLastAccrualByCard
  @offers.Action fetchLastOffers

  created () {
    this.cards.forEach(card => this.fetchLastAccrualByCard(card.cardId))
    this.fetchLastOffers()
  }

  get lastActiveOffers () {
    const currentTime = new Date()

    return this.lastOffers.filter(({ endDate }) => dayjs(fixIsoDate(endDate)).isAfter(currentTime))
  }
}

export default Dashboard
</script>

<style lang="scss">
.offer-spinner {
  margin: 50px auto;
}
</style>
